export const getLanguage = () => localStorage.getItem('lang')
export const setLanguage = (language) => localStorage.setItem('lang', language)
